import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, Switch } from 'react-router-dom';

import Constants from "../utils/Constants";
import Patterns from "../containers/Patterns";

function TrendsRouter(props) {
	let {updateHeader, resetHeader, showSnackbar, setBannerClassName,
			setFullScreenClassName, hasNudgeBanner, history, previousLocation} = props,
		routes = TrendsRouter.getRoutes();

	return (
		<Switch>
			<Redirect
				exact
				from={routes[0]}
				to={routes[1]} />
			{/* with viewType in url for tracking */}
			<Route
				path={[routes[3], routes[4]]}
				render={renderProps =>
					<Patterns
						{...renderProps}
						updateHeader={updateHeader}
						resetHeader={resetHeader}
						showSnackbar={showSnackbar}
						hasNudgeBanner={hasNudgeBanner}
						setBannerClassName={setBannerClassName}
						setFullScreenClassName={setFullScreenClassName} />
				} />

			<Route
				path={[routes[1], routes[2]]}
				render={renderProps =>
					<Patterns
						{...renderProps}
						history={history}
						previousLocation={previousLocation}
						updateHeader={updateHeader}
						resetHeader={resetHeader}
						showSnackbar={showSnackbar}
						hasNudgeBanner={hasNudgeBanner}
						setBannerClassName={setBannerClassName}
						setFullScreenClassName={setFullScreenClassName}	/>
				} />
		</Switch>
	);
}

TrendsRouter.getRoutes = () => {
	const routes = [
		"/patterns",
		`/patterns/${Constants.PATTERN.STATUSES.ACTIVE}`,
		`/patterns/${Constants.PATTERN.STATUSES.INACTIVE}`,
		"/patterns/:status/:id",
		"/patterns/:status/:id/:viewType"
	];
	return routes;
};

TrendsRouter.propTypes = {
	history: PropTypes.object.isRequired,
	location: PropTypes.object.isRequired,
	previousLocation: PropTypes.object,
	updateHeader: PropTypes.func,
	resetHeader: PropTypes.func,
	showSnackbar: PropTypes.func,
	setBannerClassName: PropTypes.func,
	hasNudgeBanner: PropTypes.bool,
	setFullScreenClassName: PropTypes.func
};

export default TrendsRouter;